import type { JSX, SVGProps } from "react";

export function PurpleIndicator({
    stroke = "#8124D1",
    fill = "#5D149A",
    ...rest
}: SVGProps<SVGSVGElement>): JSX.Element {
    return (
        <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M27 14C26.9973 12.2179 25.9072 10.6178 24.2495 9.96289C24.9647 8.32806 24.605 6.42204 23.343 5.16028C22.0811 3.89852 20.1747 3.53883 18.5397 4.25397C17.8886 2.59284 16.2863 1.5 14.5019 1.5C12.7175 1.5 11.1153 2.59284 10.4642 4.25397C8.82912 3.53883 6.9228 3.89852 5.66084 5.16028C4.39889 6.42204 4.03914 8.32806 4.75439 9.96289C3.09301 10.6139 2 12.2159 2 14C2 15.7841 3.09301 17.3861 4.75439 18.0371C4.03914 19.6719 4.39889 21.578 5.66084 22.8397C6.9228 24.1015 8.82912 24.4612 10.4642 23.746C11.1153 25.4072 12.7175 26.5 14.5019 26.5C16.2863 26.5 17.8886 25.4072 18.5397 23.746C20.1747 24.4612 22.0811 24.1015 23.343 22.8397C24.605 21.578 24.9647 19.6719 24.2495 18.0371C25.9072 17.3822 26.9973 15.7821 27 14Z"
                fill={fill}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M27.4375 14C27.4347 12.1555 26.3066 10.4996 24.5913 9.82174C25.3314 8.12976 24.9591 6.1571 23.6533 4.85123C22.3474 3.54536 20.3747 3.1731 18.6828 3.91324C18.009 2.19403 16.351 1.06299 14.5045 1.06299C12.658 1.06299 11 2.19403 10.3263 3.91324C8.63428 3.1731 6.66162 3.54536 5.35575 4.85123C4.04988 6.1571 3.67761 8.12976 4.41775 9.82174C2.69855 10.4955 1.5675 12.1535 1.5675 14C1.5675 15.8465 2.69855 17.5045 4.41775 18.1782C3.67761 19.8702 4.04988 21.8429 5.35575 23.1487C6.66162 24.4546 8.63428 24.8269 10.3263 24.0867C11 25.8059 12.658 26.937 14.5045 26.937C16.351 26.937 18.009 25.8059 18.6828 24.0867C20.3747 24.8269 22.3474 24.4546 23.6533 23.1487C24.9591 21.8429 25.3314 19.8702 24.5913 18.1782C26.3066 17.5004 27.4347 15.8444 27.4375 14Z"
                stroke={stroke}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
